import React from 'react';
import Link from 'next/link';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface AuthCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
  footerText?: string;
  footerLinkText?: string;
  footerLinkHref?: string;
}

/**
 * AuthCard - Reusable card wrapper for authentication forms
 * Provides consistent header, content area, and optional footer with link to alternate auth flow
 */
export function AuthCard({
  title,
  description,
  children,
  footerText,
  footerLinkText,
  footerLinkHref,
}: AuthCardProps) {
  return (
    <Card>
      <CardHeader className="space-y-s1">
        <CardTitle className="text-lg text-center">
          {title}
        </CardTitle>
        <CardDescription className="text-center">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {children}
        
        {footerText && footerLinkText && footerLinkHref && (
          <div className="mt-s4 text-center text-sm">
            <span className="text-[rgb(var(--text-muted))]">{footerText} </span>
            <Link href={footerLinkHref} className="text-[rgb(var(--text-primary))] hover:text-[rgb(var(--text-primary))] underline">
              {footerLinkText}
            </Link>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
